import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import styled from 'styled-components';
import PromoterDefault from 'components/PromoterDefault';
import { PromoterOnboardingSuccessModal } from 'components/PromoterOnboardingSuccessModal';
import { UpcomingEvents } from 'components/UpcomingEvents';
import { VideoResourcesCarousel as VideoResources } from 'components/Video';
import { WeatherWidget } from 'components/Weather';
import { useMe } from 'hooks/useMe';
import { AppContext } from 'shared/AppContext';
import storage from 'shared/storage';
import { Metrics } from '../Metrics';
import PermissionModal from '../PermissionModal/PermissionModal';

const FlexContainer = styled.div`
  @media (min-width: 768px) {
    display: flex;
  }
`;

export const TrackHome = (props) => {
  const {
    state: { user, accountId, capabilities },
  } = useContext(AppContext);
  const { data: meData } = useMe();

  const hasOwnership = !user.accounts.length ? false : true;

  const [accessDenied, setAccessDenied] = useState(
    props.location?.state?.from?.accessDenied
  );
  const [showOnboardingModal, setShowOnboardingModal] = useState(false);

  const { pathname } = useLocation();
  const userType = pathname.split('/').includes('admin-employee')
    ? 'employee'
    : 'track';

  // Get current account info from ME query
  const currentAccount = meData?.me?.accounts?.find(
    (account) => account.id === accountId
  );

  // Check if we should show the onboarding success modal
  useEffect(() => {
    const hasShownOnboardingModal = storage.get('hasShownOnboardingModal');

    // Show modal if:
    // 1. User has stripe capability
    // 2. Current account exists and stripe is not active
    // 3. We haven't shown the modal in this session yet
    if (
      capabilities?.stripe &&
      currentAccount &&
      currentAccount.stripe_active === false &&
      !hasShownOnboardingModal
    ) {
      setShowOnboardingModal(true);
    }
  }, [currentAccount, capabilities]);

  const handleHideOnboardingModal = () => {
    setShowOnboardingModal(false);
    // Set flag so we don't show it again in this session
    storage.set('hasShownOnboardingModal', true);
  };
  return (
    <div style={{ boxSizing: 'border-box' }}>
      <FlexContainer>
        {!hasOwnership ? (
          <PromoterDefault />
        ) : (
          <Fragment>
            <UpcomingEvents />
            <WeatherWidget Width="377px" showButton={true} />
            <Metrics />
          </Fragment>
        )}
      </FlexContainer>

      {hasOwnership && <VideoResources />}

      <PermissionModal
        isVisible={accessDenied}
        hideModal={() => setAccessDenied(false)}
        link={`/admin-${userType}/settings/1`}
        history={props.history}
      />

      <PromoterOnboardingSuccessModal
        isVisible={showOnboardingModal}
        hideModal={handleHideOnboardingModal}
        businessName={currentAccount?.business_dba}
        accountId={accountId}
      />
    </div>
  );
};
